import Section from "./Section";
import Link from "next/link";
export default function CTASection({
  eyebrow = "Get early access",
  title = "Ship a referral program today, not next month.",
  description = "Join product and growth teams piloting GrowthRail. Free during early access, no credit card required.",
}: {
  eyebrow?: string;
  title?: string;
  description?: string;
}) {
  return (
    <Section id="waitlist" className="overflow-hidden py-2">
      <div className="relative isolate overflow-hidden rounded-[2rem] border border-white/[0.1] bg-gradient-to-b from-zinc-950 to-[#121212] px-6 py-16 sm:px-12 sm:py-20">
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0 bg-grid opacity-30"
        />
        <div
          aria-hidden
          className="pointer-events-none absolute -top-40 left-1/2 h-[420px] w-[820px] -translate-x-1/2 rounded-full bg-[radial-gradient(closest-side,rgba(184,115,51,0.35),transparent_70%)] blur-3xl"
        />

        <div className="relative mx-auto max-w-2xl text-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-copper-700/40 bg-copper-900/20 px-3 py-1 text-[11px] font-medium uppercase tracking-[0.18em] text-copper-300">
            <span className="h-1.5 w-1.5 rounded-full bg-copper-400 shadow-[0_0_8px_rgba(208,129,74,0.8)]" />
            {eyebrow}
          </div>
          <h2 className="mt-5 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl md:text-5xl">
            {title}
          </h2>
          <p className="mt-5 text-base leading-relaxed text-zinc-400 sm:text-lg">
            {description}
          </p>

          <div className="mx-auto mt-8 flex justify-center">
            <Link
              href="https://app.growthrail.dev/auth"
              className="group relative inline-flex items-center justify-center gap-2 overflow-hidden rounded-full border border-copper-300/30 bg-gradient-to-b from-copper-400 to-copper-600 px-8 py-3.5 text-sm font-semibold text-white shadow-[0_0_40px_rgba(184,115,51,0.3)] transition-all hover:from-copper-300 hover:to-copper-500 hover:shadow-[0_0_60px_rgba(184,115,51,0.5)] hover:-translate-y-0.5"
            >
              <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/25 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
              Start for free
              <svg className="h-4 w-4 transition-transform group-hover:translate-x-1" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path d="M5 10h10m0 0l-4-4m4 4l-4 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" fill="none" />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </Section>
  );
}
